import { fetchRequestWithTypes } from './index.js';

export const GET_PX_QUESTIONS_REQUEST = 'GET_PX_QUESTIONS_REQUEST';
export const GET_PX_QUESTIONS_SUCCESS = 'GET_PX_QUESTIONS_SUCCESS';
export const GET_PX_QUESTIONS_ERRORED = 'GET_PX_QUESTIONS_ERRORED';

export const getQuestions = (oId) => {
  return fetchRequestWithTypes({
    types: [GET_PX_QUESTIONS_REQUEST, GET_PX_QUESTIONS_SUCCESS, GET_PX_QUESTIONS_ERRORED],
    pxQuestionType: oId,
    request: {
      method: 'GET',
      path: `/apis/customers/v1/questions/${oId}`,
    },
  });
};

export const PUT_PX_QUESTIONS_REQUEST = 'PUT_PX_QUESTIONS_REQUEST';
export const PUT_PX_QUESTIONS_SUCCESS = 'PUT_PX_QUESTIONS_SUCCESS';
export const PUT_PX_QUESTIONS_ERRORED = 'PUT_PX_QUESTIONS_ERRORED';

export const putQuestions = (oId, answer) => {
  return fetchRequestWithTypes({
    types: [PUT_PX_QUESTIONS_REQUEST, PUT_PX_QUESTIONS_SUCCESS, PUT_PX_QUESTIONS_ERRORED],
    pxQuestionType: oId,
    request: {
      method: 'PUT',
      path: `/apis/customers/v1/questions/${oId}`,
      body: { 
        answer: {
          value: answer,
         },
      },
    },
  });
};
